import { makeStyles } from '@material-ui/core'
import { css } from 'styled-components'
import { content } from '~/themes/colors'

export const phoneFieldStyle = css`
	width: 100%;
`
export const labelStyle = css`
	font-weight: 600;
	font-size: 12px;
	line-height: 18px;
	display: flex;
	align-items: center;
	letter-spacing: 0.1px;
	color: ${({ theme }) => theme.palette.primary.main};
	text-transform: capitalize;
`

export const useStyles = makeStyles((theme) => ({
	label: {
		color: theme?.palette?.primary?.main,
		marginBottom: 4,
		...theme?.typography?.subtitle2,
	},
	root: {
		'& .MuiInputBase-root': {
			'& .MuiInputBase-input': {
				...theme.typography.body1,
				padding: '8px 0',

				'&::placeholder': {
					color: content.dark,
					opacity: 1,
					fontWeight: 400,
				},
			},
		},
	},
}))
